/** @format */

import { createFileRoute } from "@tanstack/react-router";
import { Suspense } from "react";

import { lazyWithRetry } from "@/utils/lazyWithRetry";
import PageLoader from "@/utils/PageLoader";
import { RouteErrorComponent } from "@/utils/RouteErrorComponent";

const WeekendPrintPage = lazyWithRetry(
  () => import("@/pages/WeekendPrint/WeekendPrint")
);

export const Route = createFileRoute("/schedule/print/$weekend")({
  component: () => (
    <Suspense fallback={<PageLoader />}>
      <WeekendPrintPage />
    </Suspense>
  ),
  errorComponent: RouteErrorComponent,
});
